/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { FooterMultiStepProgress } from '../../../step-navigation/footerMultiStepProgress';

import { COB_API_TYPE } from '../../../../types/online-forms.types';

import useCobStore from '../../../../store/cob-store';
import { OtherQuestioner } from '../other-questioner';
import { MedicareQuestioner } from '../../medicare-insurance-detail/medicare-Questioner';

export function CheckFlow(props: any) {
  const { partnerToken } = props;
  const navigate = useNavigate();
  const [isNoNext, setNoNext] = useState<boolean>(false);
  const [moveNextOrSubmit, setMoveNextOrSubmit] = useState<boolean>(false);

  const cobResponse = useCobStore((state: any) => state.cobInformation);
  const demographics = useCobStore((state: any) => state.demographics);
  let sectionList: any = [];

  const otherFlow: Array<any> = [
    <OtherQuestioner hideClose partnerToken={partnerToken} />,
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const medicareFlow: Array<any> = [
    <MedicareQuestioner
      showFooter="false"
      hideClose="true"
      partnerToken={partnerToken}
    />,
  ];

  const findQuestionerFlow = (sectionInfo: any) =>
    sectionInfo?.find(
      (item: any) =>
        item.member.firstName === demographics?.demographics?.firstName,
    );

  const closeCOBForm = () => {
    navigate(-1);
  };

  const generateNextFlow = useMemo(() => {
    const checkAdditional = findQuestionerFlow(cobResponse.additionalInsurance);
    const checkMedicare = findQuestionerFlow(cobResponse.medicare);
    const hasAdditionalDetails = cobResponse.additionalInsurance?.find(
      (item: any) => item.hasAdditionalInsurance === 'Y',
    );
    const hasMedicareDetails = cobResponse.medicare?.find(
      (item: any) => item.hasMedicare === 'Y',
    );
    if (demographics !== null) {
      if (
        checkAdditional?.hasAdditionalInsurance === 'Y' &&
        checkMedicare?.hasMedicare === 'N'
      ) {
        sectionList.push(...otherFlow);
      } else if (
        checkAdditional?.hasAdditionalInsurance === 'N' &&
        checkMedicare?.hasMedicare === 'Y'
      ) {
        sectionList.push(...medicareFlow);
      } else if (
        checkAdditional?.hasAdditionalInsurance === 'Y' &&
        checkMedicare?.hasMedicare === 'Y'
      ) {
        sectionList = [
          <OtherQuestioner hideClose partnerToken={partnerToken} />,
        ];
      } else {
        sectionList = [];
        if (localStorage.length !== 0) {
          if (
            hasAdditionalDetails?.length > 0 &&
            hasMedicareDetails?.length > 0
          ) {
            setNoNext(false);
            setMoveNextOrSubmit(true);
          } else {
            setNoNext(true);
            setMoveNextOrSubmit(false);
          }
        }
      }
    }
  }, [sectionList]);

  useEffect(() => {}, [cobResponse, demographics, generateNextFlow]);

  // eslint-disable-next-line no-empty-pattern
  const [] = useState({
    flowForm: '',
  });

  return (
    <StackLayout
      horizontalAlignment="center"
      css={{ position: 'relative', minHeight: '100vh' }}
      data-testid="check-flow"
    >
      <FooterMultiStepProgress
        list={sectionList}
        closeForm={closeCOBForm}
        checkNoNext={isNoNext}
        moveNextOrSubmit={moveNextOrSubmit}
        formName={COB_API_TYPE.OTHER_INSURANCE}
        partnerToken={partnerToken}
      />
    </StackLayout>
  );
}
